export default __webpack_public_path__ + "static/media/offsiteAutobusIconEmpty.23d47083.svg";